/* Knobs.co — Price Request handler (Worker-backed, truthful success).
   ─────────────────────────────────────────────────────────────────
   For $0 / quote-only products. Submits the request as JSON to the same
   Cloudflare Worker the Trade application uses (form data-endpoint attr,
   type:"price-request"). The Worker creates/updates a Shopify customer
   tagged `price-request` with a product/SKU note via the Admin API and
   returns ok ONLY after Shopify confirms the write.

   Success is shown ONLY on confirmed ok:true — never on faith. On any
   failure the customer sees an error with a phone fallback, so a lost
   request is never silently swallowed. On confirmed success we also fire
   the Klaviyo identify + "Price Request Submitted" event for tracking.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-prq]');
  if (!root) return;

  var form = root.querySelector('[data-prq-form]');
  var errEl = root.querySelector('[data-prq-error]');
  var successEl = root.querySelector('[data-prq-success]');
  var endpoint = form ? form.getAttribute('data-endpoint') : '';
  var eventName = root.getAttribute('data-klaviyo-event') || 'Price Request Submitted';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var FALLBACK = ' Please call 800-530-8245 and we’ll price it for you directly.';

  function klaviyoPush(tuple) {
    try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(tuple); return true; }
    catch (e) { return false; }
  }
  function val(name) {
    if (!form) return '';
    var el = form.elements[name];
    return el ? (el.value || '').trim() : '';
  }
  function attr(name) { return root.getAttribute(name) || ''; }
  function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
  function clearError() { if (errEl) { errEl.textContent = ''; errEl.hidden = true; } }

  function openForm() {
    root.hidden = false;
    try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    var email = form && form.elements['email'];
    if (email) { try { email.focus({ preventScroll: true }); } catch (e) {} }
  }
  function closeForm() { root.hidden = true; }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-price-request-open]')) { e.preventDefault(); openForm(); return; }
    if (e.target.closest('[data-prq-close]')) { e.preventDefault(); closeForm(); }
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var d = {
        type: 'price-request',
        name: val('name'),
        email: val('email'),
        phone: val('phone'),
        message: val('message'),
        fax: val('fax'), /* honeypot */
        variant_id: attr('data-variant-id'),
        product_title: attr('data-product-title'),
        product_sku: attr('data-product-sku'),
        product_url: attr('data-product-url')
      };

      if (!EMAIL_RE.test(d.email)) {
        return showError('Please enter a valid email so we can send you pricing.');
      }
      if (!endpoint || !window.fetch) {
        return showError('We couldn’t open a connection.' + FALLBACK);
      }

      var btn = form.querySelector('button[type=submit]');
      var btnLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      function restore() { if (btn) { btn.disabled = false; btn.textContent = btnLabel; } }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d)
      }).then(function (r) {
        return r.json().catch(function () { return { ok: false }; });
      }).then(function (res) {
        if (!res || res.ok !== true) {
          restore();
          return showError('Something went wrong sending your request.' + FALLBACK);
        }

        /* confirmed write — now (and only now) success + Klaviyo */
        klaviyoPush(['identify', {
          '$email': d.email,
          '$first_name': d.name,
          '$phone_number': d.phone
        }]);
        klaviyoPush(['track', eventName, {
          product_title: d.product_title,
          product_sku: d.product_sku,
          product_vendor: attr('data-product-vendor'),
          product_url: d.product_url,
          message: d.message,
          source: 'price-request-pdp'
        }]);

        if (successEl) {
          form.hidden = true;
          successEl.hidden = false;
          try { successEl.setAttribute('tabindex', '-1'); successEl.focus(); } catch (e) {}
          try { successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        }
      }).catch(function () {
        restore();
        showError('We couldn’t reach the request service.' + FALLBACK);
      });
    });
  }

  // Collection cards link here with #price-request — auto-open on arrival.
  if (window.location.hash === '#price-request') {
    if (document.readyState !== 'loading') openForm();
    else document.addEventListener('DOMContentLoaded', openForm);
  }
})();
